import React from 'react';

import { Guideline } from "../..";
import { createStyles } from "./styles";

var BCQuestionEntity = function BCQuestionEntity(props) {
  var label = props.label,guidelines = props.guidelines,children = props.children,showGuidelinesByDefault = props.showGuidelinesByDefault;
  var classes = createStyles(props);

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.question },
    label.length > 0 && /*#__PURE__*/
    React.createElement("div", { className: classes.descriptionBlock }, /*#__PURE__*/
    React.createElement("h3", { className: classes.title, dangerouslySetInnerHTML: { __html: label } }),
    guidelines && /*#__PURE__*/
    React.createElement(Guideline, {
      type: "QUESTION",
      text: guidelines,
      showGuidelinesByDefault: showGuidelinesByDefault,
      width: "65%" })), /*#__PURE__*/




    React.createElement("div", { className: classes.contentWrapper }, children)));


};

export default BCQuestionEntity;
//# sourceMappingURL=index.js.map